var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "twitter-icon_svg__at-icon twitter-icon_svg__at-icon-twitter"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.996 10.116c-.81.36-1.68.602-2.592.71a4.526 4.526 0 001.984-2.496 9.037 9.037 0 01-2.866 1.095 4.513 4.513 0 00-7.69 4.116 12.81 12.81 0 01-9.3-4.715 4.49 4.49 0 00-.612 2.27 4.51 4.51 0 002.008 3.755 4.495 4.495 0 01-2.044-.564v.057a4.515 4.515 0 003.62 4.425 4.52 4.52 0 01-2.04.077 4.517 4.517 0 004.217 3.134 9.055 9.055 0 01-5.604 1.93A9.18 9.18 0 016 23.85a12.773 12.773 0 006.918 2.027c8.3 0 12.84-6.876 12.84-12.84 0-.195-.005-.39-.014-.583a9.172 9.172 0 002.252-2.336",
    fillRule: "evenodd"
  })));
}
export default SvgTwitterIcon;